import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button, Grid, MenuItem, Typography } from '@material-ui/core';
import { NoteAdd } from '@material-ui/icons';
import PageContainer from '../Common/PageContainer';
import FormActions from '../Common/FormActions';
import SelectField from '../Common/SelectField';

// -------------- Styles --------------
const useStyles = makeStyles((theme: Theme) => ({
    // panel de ayuda: a la derecha en desktop, debajo del formulario en pantallas angostas
    contentAside: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'right',
            paddingTop: theme.spacing(5),
        },
    },
}));

// - in this part all the component texts are housed
const texts = {
    header: {
        title: 'Migrar terceros'
    },
    body: {
        field: {
            lastThird: {
                name: 'lastThird',
                helperText: 'Escoja el tercero a migrar',
                options: [
                    {
                        id: '12',
                        name: 'Pedro',
                        secondName: 'Alfonso',
                        lastName: 'Marin'
                    },
                    {
                        id: '13',
                        companyName: 'Electrosuaza ltda'
                    }
                ]
            },
            newThird: {
                name: 'newThird',
                helperText: 'Escoja el nuevo tercero',
                options: [
                    {
                        id: '12',
                        name: 'Pedro',
                        secondName: 'Alfonso',
                        lastName: 'Marin'
                    },
                    {
                        id: '13',
                        companyName: 'Electrosuaza ltda'
                    }
                ]
            }
        },
        aside: {
            title: 'Necesitas ayuda?',
            content: 'La migración de terceros es la manera de transferir los registros de un tercero a otro tercero. Esto te será útil en caso de querer unificar un tercero que tengas duplicado.'
        }
    }
}

// ------------- Init state -----------
const initStateForm = {
    lastThird: '',
    newThird: ''
}

export default function ThirdMigration() {

    const classes = useStyles();

    const [ form, setForm ] = useState(initStateForm);
    const [ newThirdOptions, setNewThirdOptions ] = useState(texts.body.field.lastThird.options);

    // HandleChange is the handler to update the state
    // of the form, while the user change the options 
    // on an input select.
    const handleChangeSelect = (name: string, value: string) => {
        // this code removes the option slected on the lastThird
        // from the third array, with this if the user wants to
        // transfer from one third to another the new options will
        // be the other thirds.
        if(name === 'lastThird'){
            let res = texts.body.field.lastThird.options.filter(e => e.id !== value);
            setNewThirdOptions(res);
        }

        setForm({
            ...form,
            [name]: value,
        });
    }

    // HandleSubmit is the handler to verify and send
    // the form to redux (redux send the info to backend)
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    }

    const optionLabel = (e: any) =>
        // if the third has a name, it will show it
        // else it will show the company name
        e.name ? `${e.name} ${e.secondName} ${e.lastName}` : e.companyName

    return (
        <PageContainer title={texts.header.title}>
            {/* ----- Body ------*/}
            <Grid container spacing={3}>
                <Grid item md={7} sm={12} xs={12}>

                    <form onSubmit={(e) => handleSubmit(e)}>
                        <Grid container spacing={3}>
                            {/* ----- Form: item last thrid ------*/}
                            <Grid item xs={12}>
                                <SelectField
                                    name={texts.body.field.lastThird.name}
                                    label="Tercero a migrar"
                                    value={form.lastThird}
                                    helperText={texts.body.field.lastThird.helperText}
                                >
                                    {
                                        texts.body.field.lastThird.options.map((e, index) =>
                                            <MenuItem
                                                key={index}
                                                value={e.id}
                                                onClick={() => handleChangeSelect(texts.body.field.lastThird.name, e.id)}
                                            >
                                                {optionLabel(e)}
                                            </MenuItem>
                                        )
                                    }
                                </SelectField>
                            </Grid>

                            {/* ----- Form: item new thrid ------*/}
                            <Grid item xs={12}>
                                <SelectField
                                    name={texts.body.field.newThird.name}
                                    label="Nuevo tercero"
                                    value={form.newThird}
                                    helperText={texts.body.field.newThird.helperText}
                                >
                                    {
                                        newThirdOptions.map((e, index) =>
                                            <MenuItem
                                                key={index}
                                                value={e.id}
                                                onClick={() => handleChangeSelect(texts.body.field.newThird.name, e.id)}
                                            >
                                                {optionLabel(e)}
                                            </MenuItem>
                                        )
                                    }
                                </SelectField>
                            </Grid>
                        </Grid>

                        <FormActions>
                            <Button type="submit" variant="contained" color="primary" startIcon={<NoteAdd />}>
                                Migrar
                            </Button>
                        </FormActions>
                    </form>

                </Grid>

                {/* ------------ Aside -----------------*/}
                <Grid item md={5} sm={12} xs={12} className={classes.contentAside}>
                    <Typography color='primary' variant='h6'>{texts.body.aside.title}</Typography>
                    <Typography variant='body2'>{texts.body.aside.content}</Typography>
                </Grid>
            </Grid>
        </PageContainer>
    )
}
